var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3543 7.65092L16.3479 7.65089M19.5229 2.84983L13.7226 2.40365C13.2083 2.36409 12.7024 2.55122 12.3377 2.91593L2.91787 12.3358C2.2279 13.0258 2.2279 14.1444 2.91787 14.8344L9.16441 21.081C9.85439 21.7709 10.9731 21.7709 11.663 21.081L21.0829 11.6611C21.4476 11.2964 21.6347 10.7905 21.5952 10.2763L21.149 4.47591C21.0822 3.60704 20.3918 2.91667 19.5229 2.84983Z",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferTag);
export default __webpack_public_path__ + "static/media/OfferTag.885cf01f6b40ed2359a49bf901f7d11d.svg";
export { ForwardRef as ReactComponent };